module.exports = __webpack_public_path__ + "static/media/9.65dcd7f1.jpeg";